import React, { useState, useEffect } from 'react'
import { useGetAllBimlinks } from 'lib/react-query/queries'
import { useSearchTable } from 'context/SearchTableContext'
import ArticulosTableLoader from 'components/Loaders/ArticulosTableLoader'
import { ReusableTable } from 'components/Tables/ReusableTable'
import Pagination from 'components/ui/Pagination/Pagination'
import EditBimLinkButton from './EditBimLinkButton'
import DeleteBimLinkButton from './DeleteBimLinkButton'

export const TableAllBimLinks_v2 = () => {
  const { searchedValue } = useSearchTable()
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 12

  // Al cambiar el filtro, reiniciamos a la primera página
  useEffect(() => {
    setCurrentPage(1)
  }, [searchedValue])

  const options = {
    sort: 'code',
    limit: itemsPerPage,
    filter: searchedValue || '',
    page: currentPage,
  }

  const { data, isLoading, isError } = useGetAllBimlinks(options)
  if (isLoading) return <ArticulosTableLoader />
  if (isError) return <p>Error al cargar los datos: {isError.message}</p>

  const bimlinks = data?.data?.data || []
  const totalItems = data?.data?.total || 0
  const totalPages =
    data?.data?.totalPages ?? Math.ceil(totalItems / itemsPerPage)

  if (bimlinks.length === 0)
    return <p className="not-articulos-text">Ningún bimlink encontrado</p>

  // Preparamos el body para ReusableTable
  const dataBody = bimlinks.map(bimlink => [
    bimlink.code,
    <div className="bimlink-table-row-container" key={bimlink._id}>
      <div className="bimlink-table-row-buttons-container">
        <EditBimLinkButton bimlink={bimlink} />
        <DeleteBimLinkButton bimlink={bimlink} />
      </div>
    </div>,
  ])

  return (
    <div className="table-datos-page-container">
      <ReusableTable
        dataHeader={['Bimlinks', '']}
        dataBody={dataBody}
        headerClassNames={['ta-left']}
      />
      <br />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePage={setCurrentPage}
      />
    </div>
  )
}
